"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetSignatureEvent = exports.FinishSignatureEvent = exports.CancelSignatureEvent = exports.StateChangeSignatureEvent = exports.ErrorSignatureEvent = exports.ValidateSignatureEvent = exports.ShowSignatureEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class ShowSignatureEvent extends web_ui_framework_1.Event {
}
exports.ShowSignatureEvent = ShowSignatureEvent;
class ValidateSignatureEvent extends web_ui_framework_1.Event {
}
exports.ValidateSignatureEvent = ValidateSignatureEvent;
class ErrorSignatureEvent extends web_ui_framework_1.Event {
}
exports.ErrorSignatureEvent = ErrorSignatureEvent;
class StateChangeSignatureEvent extends web_ui_framework_1.Event {
}
exports.StateChangeSignatureEvent = StateChangeSignatureEvent;
class CancelSignatureEvent extends web_ui_framework_1.Event {
}
exports.CancelSignatureEvent = CancelSignatureEvent;
class FinishSignatureEvent extends web_ui_framework_1.Event {
}
exports.FinishSignatureEvent = FinishSignatureEvent;
class ResetSignatureEvent extends web_ui_framework_1.Event {
}
exports.ResetSignatureEvent = ResetSignatureEvent;
//# sourceMappingURL=signatureEvents.js.map